import { render } from "./CustomSearchComUf.vue?vue&type=template&id=c89a153c&ts=true"
import script from "./CustomSearchComUf.vue?vue&type=script&lang=ts"
export * from "./CustomSearchComUf.vue?vue&type=script&lang=ts"

import "./CustomSearchComUf.vue?vue&type=style&index=0&id=c89a153c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Search/CustomSearchComUf.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c89a153c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c89a153c', __exports__)) {
    api.reload('c89a153c', __exports__)
  }
  
  module.hot.accept("./CustomSearchComUf.vue?vue&type=template&id=c89a153c&ts=true", () => {
    api.rerender('c89a153c', render)
  })

}


export default __exports__